import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[autoFoco]'
})
export class AutoFocoDirective implements AfterContentInit {

     @Input() public autoFoco: boolean;

    public constructor(private el: ElementRef) {

    }

    public ngAfterContentInit() {
        setTimeout(() => {
            this.el.nativeElement.focus();
        }, 100);

    }

    ngOnChanges() { 
          this.el.nativeElement.focus();
      }

}